export const initialState = {
    filter: {
        createdAtStartDate: null,
        createdAtEndDate: null,
        questionnaireNameKeyword: null,
        page: null,
        size: null
    },
    isFilter: false,
    typeAction: null
  };
  
  const AplicationSearchReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SET_FILTER_APLICATION":
        return {
          ...state,
          filter: action.filter,
          isFilter: action.isFilter,
          typeAction: action.typeAction,
          page: action.page,
          size: action.size
        };
      default:
        return state;
    }
  };
  
  export default AplicationSearchReducer;
  